import { useEffect } from 'react';
export function useElementHeight(ref, onHeightChange, active = true) {
    useEffect(() => {
        if (!onHeightChange)
            return;
        if (!active || !ref.current) {
            onHeightChange(0);
            return;
        }
        const el = ref.current;
        const reportHeight = () => {
            onHeightChange(el.getBoundingClientRect().height);
        };
        reportHeight();
        const observer = new ResizeObserver(reportHeight);
        observer.observe(el);
        return () => observer.disconnect();
    }, [ref, onHeightChange, active]);
}
